import { resetApiCallState } from "../Utils";
import { SupplierActions, SupplierStateTypes } from "./Supplier.type";

const INITIAL_STATE: SupplierStateTypes = {
  fetchAll: resetApiCallState([]),
};

const SupplierReducer = (
  state: SupplierStateTypes = INITIAL_STATE,
  action: any
) => {
  switch (action.type) {
    case SupplierActions.FETCH_SUPPLIER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case SupplierActions.FETCH_SUPPLIER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: action.payload,
          isPending: false,
          isSuccessful: true,
        },
      };

    case SupplierActions.FETCH_SUPPLIER_ERROR:
      return {
        ...state,
        fetchAll: {
          error: action.payload,
          payload: [],
          isPending: false,
          isSuccessful: false,
        },
      };
    default:
      return state;
  }
};

export default SupplierReducer;
